module.exports = __webpack_public_path__ + "static/media/2020_50k.13e18098.gpx";